import { getToken } from 'src/utils/helper';
import axios from '../../../utils/axios';
import { createSlice } from '@reduxjs/toolkit';

const BILLING_URL = `${process.env.REACT_APP_BASE_URL}/billing`;

const initialState = {
  plans: [],
  status: null,
  message: null,
};

export const BillingSlice = createSlice({
  name: 'billing',
  initialState,
  reducers: {
    plansLoaded: (state, action) => {
      state.plans = action.payload;
    },
    planUpserted: (state, action) => {
      const idx = state.plans.findIndex((p) => p.id === action.payload.id);
      if (idx >= 0) {
        state.plans[idx] = action.payload;
      } else {
        state.plans = [action.payload, ...state.plans];
      }
    },
    planRemoved: (state, action) => {
      state.plans = state.plans.filter((p) => p.id !== action.payload);
    },
  },
});

export const { plansLoaded, planUpserted, planRemoved } = BillingSlice.actions;

const authHeader = () => ({ Authorization: `Bearer ${getToken()}` });

export const fetchPlans = () => async (dispatch) => {
  const res = await axios.get(`${BILLING_URL}/plans`, { headers: authHeader() });
  if (res.data.status) {
    dispatch(plansLoaded(res.data.data));
  }
};

export const createPlan = (planData) => async (dispatch) => {
  const res = await axios.post(`${BILLING_URL}/plans`, planData, { headers: authHeader() });
  if (res.data.status) {
    dispatch(planUpserted(res.data.data));
  }
  return res.data;
};

export const updatePlan = (id, planData) => async (dispatch) => {
  const res = await axios.put(`${BILLING_URL}/plans/${id}`, planData, { headers: authHeader() });
  if (res.data.status) {
    dispatch(planUpserted(res.data.data));
  }
  return res.data;
};

export const togglePlanActive = (id, active) => async (dispatch) => {
  const res = await axios.patch(`${BILLING_URL}/plans/${id}/active`, { active }, { headers: authHeader() });
  if (res.data.status) {
    dispatch(planUpserted(res.data.data));
  }
  return res.data;
};

export const deletePlan = (id) => async (dispatch) => {
  const res = await axios.delete(`${BILLING_URL}/plans/${id}`, { headers: authHeader() });
  if (res.data.status) {
    dispatch(planRemoved(id));
  }
  return res.data;
};

export default BillingSlice.reducer;
